class TabsSwitch extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.tabs = this.querySelectorAll(".tabs-switch__tab");
    this.tabButtons = this.querySelectorAll(".tabs-switch__tab-button");
    this.tops = this.querySelectorAll(".tabs-switch__top");
    this.contents = this.querySelectorAll(".tabs-switch__tab-content");

    this.tabButtons.forEach((tabButton, index) =>
      tabButton.addEventListener("click", () => this.handleClick(index))
    );
  }

  handleClick(index) {
    this.tabs.forEach((tab, idx) => {
      tab.classList.remove("active");
      this.tops[idx].classList.remove("active");
      this.contents[idx].classList.remove("active");

      if (index === idx) {
        tab.classList.add("active");
        this.tops[idx].classList.add("active");
        this.contents[idx].classList.add("active");
      }
    });
  }
}

customElements.define("tabs-switch", TabsSwitch);
